"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const URLs_1 = require("./Config/URLs");
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios_1.default.defaults.headers.common['X-CSRF-TOKEN'] = URLs_1.CSRF;
